/* Keep Shopify HeaderDrawer's focus trap and scroll lock; enhance its close control. */
(() => {
  const observers = new WeakMap();
  const docks = new WeakMap();
  function initDocks(root = document) {
    root.querySelectorAll('.zb-mobile-nav').forEach(nav => {
      if (docks.has(nav)) return;
      nav.setAttribute('data-zb-layout-ready', '');
      // Computed height is in CSS pixels, including during page magnification.
      const sync = () => document.documentElement.style.setProperty('--zb-mobile-nav-height', `${parseFloat(getComputedStyle(nav).height) || 0}px`);
      const observer = new ResizeObserver(sync);
      observer.observe(nav); docks.set(nav, observer); sync();
    });
  }
  function init(root = document) {
    root.querySelectorAll('header-drawer').forEach(drawer => {
      const details = drawer.querySelector('#Details-menu-drawer-container');
      const summary = details?.querySelector(':scope > summary');
      if (!details || !summary || observers.has(drawer)) return;
      drawer.setAttribute('data-zb-ready', '');
      const sync = () => summary.setAttribute('aria-expanded', String(details.open && details.classList.contains('menu-opening')));
      const observer = new MutationObserver(sync);
      observer.observe(details,{attributes:true,attributeFilter:['open','class']});
      observers.set(drawer,observer);sync();
    });
  }
  // Capture prevents Refresh's generic submenu-button handler treating this as Back.
  document.addEventListener('click',event => {
    const close = event.target.closest('[data-zb-drawer-close]');
    if (!close) return;
    const drawer=close.closest('header-drawer');
    const details=drawer?.querySelector('#Details-menu-drawer-container');
    const summary=details?.querySelector(':scope > summary');
    if(!summary)return;
    event.preventDefault();event.stopPropagation();
    if(typeof drawer.closeMenuDrawer==='function')drawer.closeMenuDrawer(event,summary);
    else {details.open=false;summary.focus();}
    summary.setAttribute('aria-expanded','false');
  },true);
  document.addEventListener('shopify:section:load',event=>{init(event.target);initDocks(event.target);});
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('header-drawer').forEach(drawer=>{observers.get(drawer)?.disconnect();observers.delete(drawer);}));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.zb-mobile-nav').forEach(nav => {docks.get(nav)?.disconnect();docks.delete(nav);}));
  // Observe actual CSS width without adding containment to native fixed dialogs.
  const reflow = new ResizeObserver(([entry]) => document.body.classList.toggle('zb-narrow-layout', entry.contentRect.width <= 240));
  reflow.observe(document.body);
  init(); initDocks();
})();
